import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { activityGeneralsSettingsRoutes } from 'src/app/board/activity/activity-shared/activity-generals-settings/activity-generals-settings-routes';
import { activityBenefitsRoutes } from 'src/app/board/activity/activity-benefits/activity-benefits-routes';
import { activityGroupsRoutes } from 'src/app/board/activity/activity-groups/activity-groups-routes';
import { activityRentalsRoutes } from 'src/app/board/activity/activity-rentals/activity-rentals-routes';
import { activitySalesRoutes } from 'src/app/board/activity/activity-sales/activity-sales-routes';
import { activitySavingsRoutes } from 'src/app/board/activity/activity-savings/activity-savings-routes';
import { activitySharedResourcesRoutes } from 'src/app/board/activity/activity-shared-resources/activity-shared-resources-routes';
import { activityMediaLibrariesRoutes } from 'src/app/board/activity/activity-media-libraries/activity-media-libraries-routes';
import { activityLoansRoutes } from 'src/app/board/activity/activity-loans/activity-loans-routes';
import { activityStocksRoutes } from 'src/app/board/activity/activity-shared/activity-stocks/activity-stocks-routes';

export const activityRoutes: MenuInterface[] = [
    ...activityGeneralsSettingsRoutes,
    ...activityStocksRoutes,
    ...activitySalesRoutes,
    ...activityBenefitsRoutes,
    ...activityGroupsRoutes,
    ...activityRentalsRoutes,
    ...activitySavingsRoutes,
    ...activityLoansRoutes,
    ...activityMediaLibrariesRoutes,
    ...activitySharedResourcesRoutes
];
